import pick from 'lodash/pick';
import merge from 'lodash/merge';
import isArray from 'lodash/isArray';

const basePersonnel = {
  id: undefined,
  status: {
    status: 'ACTIVE',
  },
  firstName: '',
  middleName: '',
  lastName: '',
  emailAddress: '',
  address1: '',
  address2: '',
  address3: '',
  city: '',
  stateCode: '',
  postalCode: '',
  cellPhone: '',
  workPhone: '',
  workPhoneExt: '',
  usCitizenFlag: false,
  teachingFlag: false,
  coachingFlag: false,
  counselingFlag: false,
  testPrepFlag: false,
  academicAdminFlag: false,
  clericalSupportFlag: false,
  standardTestFlag: false,
  otherJobFlag: false,
  otherJobDesc: '',
  educationLevel: null,
  expPrimaryAssessmentFlag: false,
  expCollegeAssessmentFlag: false,
  expGradAdmissionFlag: false,
  expCertLicenseFlag: false,
  expCbtFlag: false,
 // gender: null,
  //hispanicOrLatino: null,
  taAdminCount: 0,
  totalTestingExp: 0,
  firstActYear: 0,
  createdDate: '',
  modifiedDate: '',
  previouslyAdministeredTests: '',
  //personnelRaces: [],
  testCenterCyclePersonnels: [],
  testCenterEventPersonnels: [],
  inineFlag: false,
  tcmsSyncEmailAddress: undefined,
  tcmsSyncLastName: undefined,
  tcmsSyncFirstName: undefined,
  tcmsPersonnelId: undefined,
};

const baseCognitoUser = {
  userPool: 'B2B_USERPOOL',
  username: '',
  password: '',
  email: '',
  tncVersion: '',
  birthDate: '',
  appClient: 'TA_WEB',
  commPref: 'email',
  recaptchaCode: '',
};

// TODO change this to class
export class UserModel {
  constructor(data) {
    const newUser = { ...data };
    if (newUser.emailAddress) {
      newUser.email = newUser.emailAddress;
      newUser.username = newUser.emailAddress;
    }
    if (newUser.cellPhone) {
      newUser.phone = data.cellPhone;
    }

    merge(this, baseCognitoUser, pick(newUser, Object.keys(baseCognitoUser)));
  }
}

export class PersonnelModel {
  constructor(data) {
    const newUser = { ...data };
   // const demographics = pick(newUser, 'races', 'hispanicOrLatino', 'gender');
    if (isArray(data.previouslyAdministeredTests)) {
      newUser.previouslyAdministeredTests = data.previouslyAdministeredTests.join(', ');
    }

   // merge(this, basePersonnel, pick(newUser, Object.keys(basePersonnel)), demographics);

    merge(this, basePersonnel, pick(newUser, Object.keys(basePersonnel)));
  }
}
